<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default  {
  name:  'App'
}
</script>
<style lang="scss">
.tips-text{
  font-size: 14px;
  color: #97a8be;
  margin-left: 5px;
}
</style>
<style>
    .el-tooltip__popper.is-dark {
      width: 450px !important;
    }
</style>
